import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

export const useLogClickEditOff = (folderType: FolderType) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_EDIT_OFF',
      analytics: { FOLDER_TYPE: folderType },
    });
  }, [logAnalyticsEvent, folderType]);
};
